import { ref } from 'vue';
import type { StoryblokAsset } from '../types/storyblok';

interface ItemYoutubeVideoStoryblok {
  youtube_url: string;
  play_in_fullscreen?: boolean;
  poster_variant: '' | 'automatic' | 'image' | 'video';
  poster_image?: StoryblokAsset;
  poster_video?: StoryblokAsset;
  text_color: '' | 'white' | 'black';
  media_ratio: '' | '16/9' | '1/1' | '3/2' | '3/4';
  component: 'item_youtube-video';
  _uid: string;
}

interface ModalVideoStateMedia {
  type: 'media';
  filename: string;
}

interface ModalVideoStateYoutubeVideo {
  type: 'youtubeVideo';
  youtubeVideoBlok: ItemYoutubeVideoStoryblok;
}

type ModalVideoState = ModalVideoStateMedia | ModalVideoStateYoutubeVideo | null;

const state = ref<ModalVideoState>(null);

export function useModalVideo() {
  return {
    state,
  };
}
